import styled from 'styled-components';
export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-l);
  margin-block: var(--space-xxxl);

  @media screen and (max-width: 800px) {
    grid-template-columns: 1fr;
  }
`;

export const StatCard = styled.div`
  padding: var(--space-xl);

  background: var(--white);

  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 20px;

  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.05);

  display: flex;
  flex-direction: column;
  gap: var(--space-xs);

  svg {
    color: var(--orange5);
    font-size: 1.5rem;
    margin-bottom: var(--space-xs);
  }

  strong {
    color: var(--grey7);

    font-size: 1.4rem;
    line-height: 1.2;
    font-weight: 900;
  }

  span {
    color: var(--grey4);

    font-size: 0.92rem;
    font-weight: 600;
  }
`;
